let mapper_options = {
  endpoint: 'content_discovery',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('content_discovery_item', mapper_options)
}
